import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { SideNavigation, SideNavigationProps } from '@cloudscape-design/components';

const NAV_ITEMS: SideNavigationProps.Item[] = [
  { type: 'link', text: 'Models & API Keys', href: '/admin' },
  { type: 'link', text: 'Analytics', href: '/admin/analytics' },
  { type: 'link', text: 'Judge Criteria', href: '/admin/judge' },
];

export const AdminLayout: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div style={{ display: 'flex', gap: '24px' }}>
      <div style={{ minWidth: '240px' }}>
        <SideNavigation
          header={{ text: 'Admin', href: '/admin' }}
          activeHref={location.pathname}
          items={NAV_ITEMS}
          onFollow={(e) => {
            e.preventDefault();
            navigate(e.detail.href);
          }}
        />
      </div>
      <div style={{ flex: 1 }}>
        <Outlet />
      </div>
    </div>
  );
};
